import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { QuestionsProps } from './Questions.tsx';

// M10: the paint-lazy boundary now loads `QuestionsRoot`, the experiment selector that mounts either
// the Apollo control (`Questions`) or the native Relay treatment (`RelayQuestions`). The chunk name
// is preserved so the paint-optimised loading strategy is unchanged; only the module that owns the
// Apollo-vs-Relay decision moved behind the boundary. See `QuestionsRoot.tsx`.
export const LazyQuestions: LoadableType<QuestionsProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Questions" */ './QuestionsRoot.tsx'))
			.QuestionsRoot,
});
